import { IStackTokens } from '@fluentui/react';

export const tabletBreakpoint = '768px';
export const currentTenantLocalStorageKey = 'currentTenant';
export const childrenGap16: IStackTokens = { childrenGap: 16 };
